'use strict';

import {
    tabledata,
} from './common';

$.fn.serializeObject = function() {
    const o = {};
    const a = this.serializeArray();
    $.each(a, function() {
        if(o[this.name] !== undefined) {
            if(!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};


//Here we fix jquery 'position' function. It was broken between 3.2.1 and 3.3.0 in late 2017, and it is still not fixed.
//We will wait, and hope some day it will be fixed.
//See here, for a bug report which broke everything: https://github.com/jquery/jquery/issues/3107
//This is PR, with fix, which is still not merged: https://github.com/jquery/jquery/pull/3887
//There is a bunch of bug reports about this issue.
//Bootstrap-3-Typeahead relies on correct position, and currently doesn't work.
//If you ever upgrade jQuery, please look here and check if this bug was fixed.
$.fn.position = function() {
    if(!this[0]) {
        return undefined;
    }
    let offsetParent; let offset; let doc; let
        parentOffset = {
            top: 0,
            left: 0,
        };
    const elem = this[0];
    if(jQuery.css(elem, 'position') === 'fixed') {
        offset = elem.getBoundingClientRect();
    } else {
        offset = this.offset();
        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;
        //fix is here, "offsetParent && (" changed to "offsetParent && !("
        while(offsetParent && !(offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, 'position') === 'static') {
            offsetParent = offsetParent.parentNode;
        }
        if(offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
            parentOffset = jQuery(offsetParent).offset();
            parentOffset.top += jQuery.css(offsetParent, 'borderTopWidth', true);
            parentOffset.left += jQuery.css(offsetParent, 'borderLeftWidth', true);
        }
    }
    return {
        top: offset.top - parentOffset.top - jQuery.css(elem, 'marginTop', true),
        left: offset.left - parentOffset.left - jQuery.css(elem, 'marginLeft', true),
    };
};


//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
// Closure
(function() {
    /**
     * Decimal adjustment of a number.
     *
     * @param {String}  type  The type of adjustment.
     * @param {Number}  value The number.
     * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
     * @returns {Number} The adjusted value.
     */

    function decimalAdjust(type, value, exp) {
        // If the exp is undefined or zero...
        if(typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
        }
        value = +value;
        exp = +exp;
        // If the value is not a number or the exp is not an integer...
        if(isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        // Shift
        value = value.toString().split('e');
        value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
        // Shift back
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
    }

    // Decimal round
    if(!Math.round10) {
        Math.round10 = function(value, exp) {
            return decimalAdjust('round', value, exp);
        };
    }
    // Decimal floor
    if(!Math.floor10) {
        Math.floor10 = function(value, exp) {
            return decimalAdjust('floor', value, exp);
        };
    }
    // Decimal ceil
    if(!Math.ceil10) {
        Math.ceil10 = function(value, exp) {
            return decimalAdjust('ceil', value, exp);
        };
    }

    if(!Number.prototype.toFixed10) {
        // eslint-disable-next-line no-extend-native
        Number.prototype.toFixed10 = function(precision) {
            return Math.round10(this, -precision).toFixed(precision);
        };
    }
})();



//localize some builtin messages (additional-methods are not localized)
if(jQuery.validator) {
    jQuery.validator.messages.require_from_group = 'Seleziona almeno {0} di questi campi.';
    jQuery.validator.messages.skip_or_fill_minimum = 'Seleziona almeno {0} di questi campi o salta.';
    jQuery.validator.messages.bic = 'Codice BIC non valido';
    jQuery.validator.messages.iban = 'Codice IBAN non valido';
    jQuery.validator.messages.pattern = 'Valore non valido';
}

if($.fn.datetimepicker?.defaults) {
    $.fn.datetimepicker.defaults.icons = {
        time: 'bi bi-clock',
        date: 'bi bi-calendar',
        up: 'bi bi-chevron-up',
        down: 'bi bi-chevron-down',
    };
}


$.fn.cleverVal = function() {
    const $this = $(this);
    let val;
    if(!arguments.length) {
        //getter
        val = tabledata.getControlValue($this);
        return val;
    }
    //setter
    val = arguments[0];
    tabledata.setControlValue($this, val);

    return undefined;
};



//datatables are optional. add inside scope
if($.fn && $.fn.dataTableExt) {
    (function() {
        //datatables default language
        $.extend(true, $.fn.dataTable.defaults, {
            language: {
                //node_modules/datatables.net-plugins/i18n/Italian.lang
                'sEmptyTable': 'Nessun dato presente nella tabella',
                'sInfo': 'Vista da _START_ a _END_ di _TOTAL_ elementi',
                'sInfoEmpty': '0 - 0 / 0',
                'sInfoFiltered': '(filtrati da _MAX_ elementi totali)',
                'sInfoPostFix': '',
                'sInfoThousands': ',',
                'sLengthMenu': '_MENU_',
                'sLoadingRecords': 'Caricamento...',
                'sProcessing': 'Elaborazione...',
                'sSearch': 'Cerca:',
                'sZeroRecords': 'La ricerca non ha portato alcun risultato.',
                'oPaginate': {
                    'sFirst': 'Inizio',
                    'sPrevious': 'Precedente',
                    'sNext': 'Successivo',
                    'sLast': 'Fine',
                },
                'oAria': {
                    'sSortAscending': ': attiva per ordinare la colonna in ordine crescente',
                    'sSortDescending': ': attiva per ordinare la colonna in ordine decrescente',
                },
            },
        });

        const previousClassName = 'previous';
        const nextClassName = 'next';

        $.fn.dataTableExt.oPagination.listbox = {
            fnInit: function(oSettings, nPaging, fnCallbackDraw) {
                const nInput = document.createElement('select');
                const nPrevious = document.createElement('span');
                const nNext = document.createElement('span');
                const classes = oSettings.oClasses;
                const language = oSettings.oLanguage.oPaginate;
                nPrevious.innerHTML = language.sPrevious;
                nNext.innerHTML = language.sNext;
                nPrevious.className = previousClassName + ' ' + classes.sPageButton;
                nNext.className = nextClassName + ' ' + classes.sPageButton;
                if(oSettings.sTableId !== '') {
                    nPrevious.setAttribute('id', oSettings.sTableId + '_' + previousClassName);
                    nNext.setAttribute('id', oSettings.sTableId + '_' + nextClassName);
                    nPaging.setAttribute('id', oSettings.sTableId + '_paginate');
                }
                nInput.style.display = 'inline';
                nPaging.appendChild(nPrevious);
                nPaging.appendChild(nInput);
                nPaging.appendChild(nNext);
                $(nPrevious).click(function() {
                    const iCurrentPage = Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1;
                    if(iCurrentPage !== 1) {
                        oSettings.oApi._fnPageChange(oSettings, 'previous');
                        fnCallbackDraw(oSettings);
                    }
                });
                $(nNext).click(function() {
                    const iCurrentPage = Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1;
                    if(iCurrentPage !== Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)) {
                        oSettings.oApi._fnPageChange(oSettings, 'next');
                        fnCallbackDraw(oSettings);
                    }
                });
                $(nInput).change(function(e) {
                    window.scroll(0, 0);
                    if(this.value === '' || this.value.match(/[^0-9]/)) {
                        return;
                    }
                    const iNewStart = oSettings._iDisplayLength * (this.value - 1);
                    if(iNewStart > oSettings.fnRecordsDisplay()) {
                        oSettings._iDisplayStart = (Math.ceil((oSettings.fnRecordsDisplay() - 1) / oSettings._iDisplayLength) - 1) * oSettings._iDisplayLength;
                        fnCallbackDraw(oSettings);
                        return;
                    }
                    oSettings._iDisplayStart = iNewStart;
                    fnCallbackDraw(oSettings);
                });
                $('span', nPaging).bind('mousedown', function() {
                    return false;
                });
                $('span', nPaging).bind('selectstart', function() {
                    return false;
                });
            },
            fnUpdate: function(oSettings, fnCallbackDraw) {
                if(!oSettings.aanFeatures.p) {
                    return;
                }

                const iPages = Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength);
                const iCurrentPage = Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1;
                const an = oSettings.aanFeatures.p;
                for(let i = 0, iLen = an.length; i < iLen; i++) {
                    const inputs = an[i].getElementsByTagName('select');
                    const elSel = inputs[0];
                    if(elSel.options.length != iPages) {
                        elSel.options.length = 0;
                        for(let j = 0; j < iPages; j++) {
                            const oOption = document.createElement('option');
                            oOption.text = j + 1;
                            oOption.value = j + 1;
                            try {
                                elSel.add(oOption, null);
                            } catch(ex) {
                                elSel.add(oOption);
                            }
                        }
                    }

                    elSel.value = iCurrentPage;
                }
            },
        };
    })();
}


if(!window.atob) {
    const tableStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const table = tableStr.split('');

    window.atob = function(base64) {
        if(/(=[^=]+|={3,})$/.test(base64)) throw new Error('String contains an invalid character');
        base64 = base64.replace(/=/g, '');
        const n = base64.length & 3;
        if(n === 1) throw new Error('String contains an invalid character');
        const bin = [];
        for(let i = 0, j = 0, len = base64.length / 4; i < len; ++i) {
            const a = tableStr.indexOf(base64[j++] || 'A');
            const b = tableStr.indexOf(base64[j++] || 'A');
            const c = tableStr.indexOf(base64[j++] || 'A');
            const d = tableStr.indexOf(base64[j++] || 'A');
            if((a | b | c | d) < 0) throw new Error('String contains an invalid character');
            bin[bin.length] = ((a << 2) | (b >> 4)) & 255;
            bin[bin.length] = ((b << 4) | (c >> 2)) & 255;
            bin[bin.length] = ((c << 6) | d) & 255;
        }
        return String.fromCharCode.apply(null, bin).substr(0, bin.length + n - 4);
    };

    window.btoa = function(bin) {
        const base64 = [];
        for(let i = 0, j = 0, len = bin.length / 3; i < len; ++i) {
            const a = bin.charCodeAt(j++);
            const b = bin.charCodeAt(j++);
            const c = bin.charCodeAt(j++);
            if((a | b | c) > 255) throw new Error('String contains an invalid character');
            base64[base64.length] = table[a >> 2] + table[((a << 4) & 63) | (b >> 4)]
                + (isNaN(b) ? '=' : table[((b << 2) & 63) | (c >> 6)])
                + (isNaN(b + c) ? '=' : table[c & 63]);
        }
        return base64.join('');
    };
}


// requestAnimationFrame polyfill
(function() {
    let lastTime = 0;
    const vendors = ['ms', 'moz', 'webkit', 'o'];
    for(let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if(!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(
                function() { callback(currTime + timeToCall); },
                timeToCall,
            );
            lastTime = currTime + timeToCall;
            return id;
        };

    if(!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

//vue bootstrap workaround, IDK what is wrong
//TODO - debug this
//var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
const contains = $.contains;
$.contains = function(parent, element) {
    if(parent && element) {
        const owner = element.ownerDocument;
        if(((parent === owner) || (parent === owner.documentElement)) && element.getRootNode) {
            const root = element.getRootNode({ composed: true });
            return (root === owner) || (root === owner.documentElement);
        }
    }
    return contains(parent, element);
};

// Hack to enable multiple modals by making sure the .modal-open class
// is set to the <body> when there is at least one modal open left
$(function() {
    $('body').on('hidden.bs.modal', function(event) {
        const $this = $(event.target);
        if($('.modal.in').length > 0) {
            $('body').addClass('modal-open');
        }
        $($this).css('z-index', '');
    });
    $('body').on('show.bs.modal', function(event) {
        const $this = $(event.target);
        const modals = $.makeArray($('body').find('.modal.in').not($this));
        if(modals.length) {
            const zindex = modals.reduce((a, b) => Math.max(a, Number(b.style['z-index'] ?? 0)), 1050) + 1;
            $this.css('z-index', zindex);
        }
    });
    $('body').on('shown.bs.modal', function(event) {
        const backdrops = $('body').find('.modal-backdrop.in');
        if(backdrops.length > 1) {
            backdrops.each(function(index) {
                $(this).css('opacity', index ? '0' : '');
            });
        }
    });

    // On page load, drop leftover modal history entries (they keep the same URL
    // as the page) so the back button reaches the clean page URL directly.
    // All entries of a modal stack share the same unique session id, so if the
    // user then presses forward, we can detect the same stack and skip it to
    // the next clean page.
    const modalHistoryDepthKey = 'bootstrapModalDepth';
    const modalHistorySessionKey = 'bootstrapModalSession';

    function hasModalHistoryState(state) {
        return !!state && typeof state[modalHistoryDepthKey] === 'number';
    }
    function modalHistorySessionId(state) {
        return !!state && typeof state[modalHistorySessionKey] === 'string'
            ? state[modalHistorySessionKey]
            : null;
    }

    let cleaningModalHistory = false;
    let cleanedModalSessionId = null;
    let skippingModalHistoryForward = false;

    function onModalHistoryPopState() {
        const state = history.state;
        if(cleaningModalHistory) {
            if(hasModalHistoryState(state)) {
                cleanedModalSessionId = modalHistorySessionId(state) ?? cleanedModalSessionId;
                history.back();
            } else {
                cleaningModalHistory = false;
            }
            return;
        }
        if(cleanedModalSessionId === null) return;
        if(hasModalHistoryState(state) && modalHistorySessionId(state) === cleanedModalSessionId) {
            skippingModalHistoryForward = true;
            history.forward();
            return;
        }
        if(skippingModalHistoryForward) {
            skippingModalHistoryForward = false;
            cleanedModalSessionId = null;
        }
    }

    const initialState = history.state;
    if(hasModalHistoryState(initialState)) {
        cleaningModalHistory = true;
        cleanedModalSessionId = modalHistorySessionId(initialState);
        window.addEventListener('popstate', onModalHistoryPopState);
        history.back();
    }
});

document.addEventListener('click', function(e) {
    const activeElement = $(document.activeElement);
    if(activeElement.closest('.select2-drop').length || activeElement.closest('.select2-container').length) {
        //in firefox last versions 118+ when clicking on select2 it wont prevent events flow
        //so popup will catch in and close popup window, if select2 is on it
        //see select2 killEvent / killEventImmediately
        //see bootstrap Dropdown clearMenus
        //see https://github.com/select2/select2/issues/6278
        e.preventDefault();
        e.stopImmediatePropagation();
    }
}, true);
